const getters = {
    smProducts: state => state.sm_products,
    smProduct: state => state.sm_product,
    smProductFilters: state => state.sm_product_filters,
    smProductVatList: state => state.sm_product_vat_list,
}

export default getters;
